module.exports = __webpack_public_path__ + "img/ic_ruzhuyuncang@2x.a574a6ec.png";